import React, { useState } from 'react';
import {
  ButtonGroup,
  OutlineButton,
  PrimaryButton,
  Typography,
} from 'glints-aries/es/@next';
import { includes } from 'lodash-es';
import { FormattedMessage } from 'react-intl';

import useConfirmWhatsAppNumber from '../../../../../../modules/User/hooks/useConfirmWhatsAppNumber';
import { WhatsappVerificationStep } from '../../../../../WhatsappVerification/types';
import { useWhatsappVerificationContext } from '../../../../../WhatsappVerification/WhatsappVerificationContext/WhatsappVerificationContext';
import { FORM_CANCEL_VALUE, FORM_ID, FORM_SUBMIT_VALUE } from '../../../consts';

type ConfirmNumberModalFooterProps = {
  onClose: () => void;
};

export default function ConfirmNumberModalFooter({
  onClose,
}: ConfirmNumberModalFooterProps) {
  const [showSendVerificationButton, setShowSendVerificationButton] =
    useState(false);
  const { loading, stepHistory } = useWhatsappVerificationContext();
  const { refreshUpdatedAt } = useConfirmWhatsAppNumber({
    onSuccess: () => {
      onClose();
    },
  });

  const handleRefreshUpdatedAt = () => {
    refreshUpdatedAt();
    onClose();
  };
  const hasMovedToOTPStep = includes(
    stepHistory,
    WhatsappVerificationStep.InputOTP
  );

  return (
    <ButtonGroup>
      <Choose>
        <When condition={showSendVerificationButton}>
          <If condition={!hasMovedToOTPStep}>
            <OutlineButton
              form={FORM_ID[WhatsappVerificationStep.InputNumber]}
              type="submit"
              name={
                FORM_CANCEL_VALUE[
                  WhatsappVerificationStep.ConfirmWhatsappNumber
                ]
              }
              onClick={() => {
                setTimeout(() => {
                  const resetPhoneNumberButton = document.querySelector(
                    '#reset-phone-number-button'
                  ) as HTMLButtonElement | null;
                  if (resetPhoneNumberButton) {
                    resetPhoneNumberButton.click();
                  }
                  setShowSendVerificationButton(false);
                }, 0);
              }}
            >
              <Typography variant="button">
                <FormattedMessage
                  id="interactive-cancel"
                  defaultMessage="Cancel"
                />
              </Typography>
            </OutlineButton>
          </If>
          <PrimaryButton
            type="submit"
            form={FORM_ID[WhatsappVerificationStep.InputNumber]}
            loading={loading}
            disabled={loading}
          >
            <Typography variant="button">
              <FormattedMessage
                id="interactive-send-verification-code"
                defaultMessage="Send Verification Code"
              />
            </Typography>
          </PrimaryButton>
        </When>
        <Otherwise>
          <OutlineButton
            form={FORM_ID[WhatsappVerificationStep.InputNumber]}
            name={
              FORM_SUBMIT_VALUE[WhatsappVerificationStep.ConfirmWhatsappNumber]
            }
            id={'update-phone-number-button'}
            onClick={() => {
              // wait till the events are bubble up so the form picks the event up
              setTimeout(() => {
                setShowSendVerificationButton(true);
                const phoneInput = document.querySelector(
                  '.phone-number-input'
                ) as HTMLInputElement | null;
                if (phoneInput) {
                  phoneInput.focus();
                }
              }, 0);
            }}
          >
            <Typography variant="button">
              <FormattedMessage
                id="interactive-no-update-it"
                defaultMessage="No, Update It"
              />
            </Typography>
          </OutlineButton>
          <OutlineButton onClick={handleRefreshUpdatedAt}>
            <Typography variant="button">
              <FormattedMessage
                id="interactive-yes-continue"
                defaultMessage="Yes, Continue"
              />
            </Typography>
          </OutlineButton>
        </Otherwise>
      </Choose>
    </ButtonGroup>
  );
}
